import { useMemo } from 'react'
import styled from 'styled-components'

import { reatomTopTradersTable } from '@root/widgets/trade/tables/top-traders-table/atoms/reatom-top-traders-table'
import { TopTradersTable } from '@root/widgets/trade/tables/top-traders-table/ui/top-traders-table'

import type { PairModel } from '@root/entities/pair'

type TradeTopTradersTableProps = {
  pair: PairModel
}

export const TradeTopTradersTable: React.FC<TradeTopTradersTableProps> = ({
  pair,
}) => {
  const topTradersModelAtom = useMemo(() => {
    // eslint-disable-next-line @reatom/unit-naming-rule
    return reatomTopTradersTable({
      pair,
    })
  }, [pair])

  const context = useMemo(() => ({ pairAddress: pair.address }), [pair.address])

  return <Root tableModel={topTradersModelAtom} context={context} />
}

const Root = styled(TopTradersTable)`
  height: 100%;
`
